import { ItemReorderEventDetail } from "@ionic/core";
import { IonReorderGroup } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { selectQuestionList } from "../../../store/templateDetail/selectors/selectQuestionList";

import { TemplateInputItem } from "./TemplateInputItem";

export const TemplateInputsContainer = () => {
  const questionList = useSelector(selectQuestionList);

  const handleReorder = async (event: CustomEvent<ItemReorderEventDetail>) => {
    // The `from` and `to` properties contain the index of the item
    // when the drag started and ended, respectively
    // console.log("Dragged from index", event.detail.from, "to", event.detail.to);

    // if (event.detail.to < questionList.length) {
    //   dispatch(syncReorderList({ from: event.detail.from, to: event.detail.to }));
    // } else if (event.detail.to >= questionList.length) {
    //   dispatch(syncReorderList({ from: event.detail.from, to: questionList.length - 1 }));
    // }
    // Finish the reorder and position the item in the DOM based on
    // where the gesture ended. This method can also be called directly
    // by the reorder group
    event.detail.complete();
  };

  return (
    <IonReorderGroup disabled={false} onIonItemReorder={handleReorder}>
      {questionList?.map((question, index) => (
        <TemplateInputItem question={question} index={index} key={index} />
      ))}
    </IonReorderGroup>
  );
};
